module.exports = __webpack_public_path__ + "assets/img/buy-team-success-fbb51326.png";